import React, { useState } from "react";
import "./style.scss";
// import amEligible from "../../../../assets/images/am-i-eligible.png";
import amEligible from "../../../.././assets/images/Blue_Button_Rectangle.svg";
// import applyMentor from "../../../../assets/images/become-mentor.png";
import applyMentor from "../../../../assets/images/Orange button Rectangle.svg";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
export default function WhoMentor(props) {
  const history = useHistory();
  const [isShowLogin, setIsShowLogin] = useState(false);
  const { t } = useTranslation();
  const handleLoginClick2 = (buttonAction) => {
    try {
      localStorage.removeItem("activePage");
      if (localStorage.getItem("loggedIn") == null) {
          history.push({
            pathname: "/login",
            state: buttonAction,
          });
      } else {
        if (localStorage.getItem("loggedIn") === "true") {
          let value = localStorage.getItem("SavedLoggedInData");
          let LoginFormData = JSON.parse(value);
          if (
            LoginFormData?.role == "Startup" &&
            LoginFormData?.role === buttonAction
          ) {
            history.push({
              pathname: "/get-a-mentor",
              state: LoginFormData,
            });
          } else if (
            LoginFormData?.role == "Mentor" &&
            LoginFormData?.role === buttonAction
          ) {
            if(LoginFormData?.applicationStatus != "PENDING")
            {
              history.push({
                pathname: "/dashboard",
                state: LoginFormData,
              });
               
            }
            else {
              history.push({
                pathname: "/become-a-mentor",
                state: LoginFormData,
              });
            }
          
          } else {
            toast.error(
              "You have Already Logged In with " +
                LoginFormData?.role +
                ", Logout First..."
            );
          }
        } else {
          history.push({
            pathname: "/login",
            state: buttonAction,
          });
        }
      }
    } catch (error) {}

    setIsShowLogin(!isShowLogin);
  };

  const Banner = props.data[0];
  const BannerImage = Banner.BannerImage;

  return (
    <div className="WhoMentor">
      <section id="banner">
        <div className="w-100 pt-50 pb-0 position-relative">
          <div className="container">
            <div className="row">
              <div className="col-md-6 col-sm-12 col-lg-6 wow slideInLeft">
                <div
                  className="mckp-img text-center tilt w-100"
                  data-max_tilt="10"
                  data-perspective="1000"
                  data-scale="1"
                  data-speed="700"
                >
                  <img className="img-fluid" src={BannerImage} alt="" />
                </div>
              </div>
              <div className="col-md-6 col-sm-12 col-lg-6 wow slideInRight">
                <div className="content ">
                  <h2 className="mb-0 homepageFirstHeader">
                    {t("Who_Can_Become_A_Mentor")}
                    {/* Who Can Become a Mentor? */}
                  </h2>
                  <br />
                  <p className="homepageFirstDescription" style={{ textAlign: "justify", fontSize: "20px" }}>
                    {t("MAARG_Program_by_Startup_India_invites")}
                    {/* MAARG Program by Startup India invites experts
                    to register and provide guidance to startups throughout the
                    year.{" "} */}
                  </p>
                  <div className="get-mentor" onClick={() => handleLoginClick2("Mentor")}>
                    <div className="top-btn Mentor-Application newuserTooltip">
                      <img
                        // style={{ height: "4.6em", marginTop: "-6.1%" }}
                        className="becomementorbtndiv1"
                        src={applyMentor}
                        
                        alt="Slide 1 Mockup 6"
                      />
                      <div
                        class="centred col-lg-6 col-md-6 col-sm-2"
                        style={{
                          lineHeight: "25px",
                          display: "flex",
                          marginTop: "-3%",
                        }}
                      >
                        Mentor Application
                      </div>
                      <span className="tooltiptext  tooltip-bottom" style={{left:"66px",top:"89px",width:"auto"}}>
                          Click to Apply as a Mentor
                        </span>
                    </div>
                    <div className="header-cart-box-banner-btn position-relative d-inline-block ">
                      <div className="tp-caption cart-btn position-relative Mentor-Application">
                        <img
                          // style={{
                          //   height: "auto",
                          //   cursor: "pointer",
                          //   marginTop: "-27px",
                          // }}
                          width="200px"
                          src={amEligible}
                          alt=""
                          className="becomementorbtndiv2"
                        />
                        <div
                          class="centred2 col-lg-12 col-md-6 col-sm-2 becomementorbtn2"
                          // style={{ left: "49%" }}
                        >
                          Am I<br></br>
                          Eligible?
                        </div>
                      </div>
                      <div className="minicart-dropdown-banner-btn">
                        <p style={{ cursor: "default" }} className="banner-btn">
                          <a>
                            {t("A_POTENTIAL_MENTOR_NEEDS_TO_HAVE_AT_LEAST")}
                            {/* A POTENTIAL MENTOR NEEDS TO HAVE AT LEAST 7 YEARS OF
                            EXPERIENCE IN ANY OF THE BELOW TO BE ELIGIBLE FOR
                            THE PROGRAM. */}
                          </a>
                        </p>
                        <ul className="banner-list">
                          <li className="listStylepositionData">
                            {t("Building_startup_working_in_startup")}
                            {/* Building a startup or working in a startup */}
                          </li>
                          <li className="listStylepositionData">
                            {t(
                              "Investing_in_startup_helping_startups_raise_investments"
                            )}
                            {/* Investing in a startup or helping startups raise investments */}
                          </li>
                          <li className="listStylepositionData">
                            {t("Running_an_incubator_incubation_facility")}
                            {/* Running an incubator or working in an incubation facility */}
                          </li>
                          <li className="listStylepositionData">
                            {t(
                              "Running_an_accelerator_or_working_in_an_accelerator"
                            )}
                            {/* Running an accelerator or working in an accelerator */}
                          </li>
                          <li className="listStylepositionData">
                            {t("Mentoring_a_startup_in_the_past_or_being")}
                            {/* Mentoring a startup in the past or being on the
                            board of advisors of a startup */}
                          </li>
                          <li className="listStylepositionData">
                            {t(
                              "Teaching_management_or_a_technical_subject_academic_institution"
                            )}
                            {/* Teaching management or a technical subject at a
                            graduation or postgraduation academic institution */}
                          </li>
                          <li className="listStylepositionData">
                            {t("Working_with_Non_Profit_Entity")}
                            {/* Working with a State Government, Central Government, Foundation, NGO, Non-Profit Entity,
                            or any other organization to promote entrepreneurship and innovation */}
                          </li>
                          <li className="listStylepositionData">
                            {t("Working_in_a_business_vertical")}
                            {/* Working in a business vertical (such as marketing, HR, operations, business development, website or app development etc.) */}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
